import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=6c44d010&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=6c44d010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44d010",
  null
  
)

export default component.exports